import React from 'react';

import { Box, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

import DomainBreadcrumbs, { Crumb } from 'components/DomainBreadcrumbs';

type Props = {
  /** パンくず（家アイコン › ドメイン › 現在地） */
  breadcrumbs: Crumb[];
  /** 見出しアイコン */
  icon: React.ReactNode;
  /** タイトル */
  title: string;
  /** 補足説明（任意） */
  description?: string;
  /** アクセントカラー（アイコンチップ・下線）。既定はドメインテーマ色 */
  color?: string;
  /** 右側アクション（任意） */
  actions?: React.ReactNode;
  /** 下マージン（既定 2） */
  mb?: number;
};

/**
 * 設定系画面の共通ページヘッダー（モダン・コンパクト）。
 * パンくず ＋ アイコンチップ ＋ タイトル ＋ 説明 ＋ 右アクション を一体で表示する。
 * ヒーローほど大きくない、設定画面向けの引き締まった見出し。
 */
const SettingsPageHeader: React.FC<Props> = ({
  breadcrumbs,
  icon,
  title,
  description,
  color = '#6a1b9a',
  actions,
  mb = 2,
}) => (
  <Box sx={{ mb }}>
    <DomainBreadcrumbs items={breadcrumbs} mb={1} />
    <Stack direction="row" alignItems="center" spacing={1.5}>
      <Box
        sx={(t) => ({
          width: 40,
          height: 40,
          borderRadius: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: alpha(color, 0.12),
          color,
          flexShrink: 0,
          ...t.applyStyles('dark', { bgcolor: alpha(color, 0.24) }),
        })}
      >
        {icon}
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="h6" fontWeight={700} sx={{ lineHeight: 1.2 }} noWrap>
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" color="text.secondary" noWrap>
            {description}
          </Typography>
        )}
      </Box>
      {actions && <Box sx={{ flexShrink: 0 }}>{actions}</Box>}
    </Stack>
  </Box>
);

export default SettingsPageHeader;
